import { render, staticRenderFns } from "./dpie.vue?vue&type=template&id=af1e1496&scoped=true&"
import script from "./dpie.vue?vue&type=script&lang=js&"
export * from "./dpie.vue?vue&type=script&lang=js&"
import style0 from "./dpie.vue?vue&type=style&index=0&id=af1e1496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1e1496",
  null
  
)

export default component.exports